<template>
  <v-card class="mx-auto" elevation="16" max-width="100vw">
    <v-card-item>
      <v-card-title> Documentos</v-card-title>
      <v-card-subtitle>
        <v-row>
          <v-col cols="12"> Administración de Documentos </v-col>
        </v-row>

        <v-row style="margin-left: 16px; margin-right: 16px">
          <v-col cols="6">
            <v-text-field v-model="search" append-icon="fa-solid fa-search" label="Buscar" single-line hide-details />

          </v-col>

          <v-col cols="6" class="text-right">
            <div v-if="role === 'ADMIN' || role === 'SUPERADMIN'">
              <v-btn class="btn-add-user" @click="newFile">
                <v-icon class="fa-solid fa-plus"></v-icon>
                Nuevo Documento
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <v-data-table-server v-model:items-per-page="itemsPerPage" v-model:page="files.page" :headers="headers"
        :items="filteredFiles" :loading="loading" :items-length="files.totalElements" @update:options="loadItems"
        :items-per-page-options="[10, 25, 50, 100]">
        <template #item="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td v-if="role === 'ADMIN' || role === 'SUPERADMIN'">
              <span :class="getStatusBadge(item.status).class">
                {{ getStatusBadge(item.status).text }}
              </span>
            </td>
            <td>{{ item.file_name }}</td>
            <td>{{ item.category }}</td>
            <td>{{ item.quarter }}</td>
            <td>{{ item.year }}</td>
            <td v-if="role === 'ADMIN' || role === 'SUPERADMIN'">
              {{ item.author }}
            </td>
            <td>{{ dateFormat(item.created_at) }}</td>
            <td>
              <div v-if="role === 'ADMIN' || role === 'SUPERADMIN'">
                <div v-if="item.status === 'ACTIVE'">
                  <v-tooltip text="Desactivar" location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" class="btn-accion" icon @click="deleteFile(item)">
                        <v-icon class="fa-solid fa-trash"></v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip text="Activar" location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" class="btn-accion" icon @click="deleteFile(item)">
                        <v-icon class="fa-solid fa-circle-check"></v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
                <v-tooltip text="Editar" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" class="btn-accion" icon @click="editFile(item)">
                      <v-icon class="fa-solid fa-pencil"></v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </div>
              <v-tooltip text="Ver pdf" location="top">
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" class="btn-accion" icon @click="seeMore(item)">
                    <v-icon class="fa-solid fa-file"></v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table-server>
    </v-card-text>
  </v-card>
  <ModalAddFile :isVisiblePdf="showModalAddFile" @update:visible="showModalAddFile = $event"
    @update:files="loadItems()" />
  <ModalUpdateDocument :isVisiblePdfU="showModalUpdateFile" :fileToEdit="selectedFile"
    @update:visible="closeModalUpdate" @update:files="loadItems()" />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { getFiles, deleteFileService } from "../services/files-service";
import ModalAddFile from "../components/ModalAddDocument.vue";
import ModalUpdateDocument from "../components/ModalUpdateDocument.vue";
import { BASEURL, getRoleByToken, formatDate } from "@/kernel/utils";
import { showErrorToast, showSuccessToast } from "@/kernel/alerts";

const files = ref({
  content: [],
  totalElements: 0,
  page: 1,
  size: 25,
});

const itemsPerPage = ref(25);
const loading = ref(false);
const search = ref("");
const showModalAddFile = ref(false);
const role = ref(null);
const selectedFile = ref(null);
const showModalUpdateFile = ref(false);
const dateFormat = (date) => {
  return formatDate(date);
};

const headersBase = [
  { title: "N°", key: "id" },
  { title: "Estado", key: "status" },
  { title: "Nombre del archivo", key: "file_name" },
  { title: "Categoría", key: "category" },
  { title: "Trimestre", key: "quarter" },
  { title: "Año", key: "year" },
  { title: "Subido por", key: "author" },
  { title: "Subido el", key: "created_at" },
  { title: "", key: "actions", sortable: false },
];

const getStatusBadge = (status) => {
  switch (status) {
    case "ACTIVE":
      return { text: "Activo", class: "badge-active" };
    case "INACTIVE":
      return { text: "Inactivo", class: "badge-inactive" };
    default:
      return { text: "Desconocido", class: "badge-default" };
  }
};

onMounted(async () => {
  loadItems();
  role.value = await getRoleByToken();
  const checkbox = document.getElementById('input-193');
if (checkbox) {
  checkbox.remove();
}

});

const headers = computed(() => {
  if (role.value !== "ADMIN" && role.value !== "SUPERADMIN") {
    return headersBase.filter((h) => h.key !== "author" && h.key !== "status");
  }
  return headersBase;
});

const loadItems = async (options) => {
  loading.value = true;
  try {
    if (options) {
      files.value.page = options.page || files.value.page;
      itemsPerPage.value = options.itemsPerPage || itemsPerPage.value;
    }

    const params = {
      page: files.value.page,
      size: itemsPerPage.value,
      search: search.value,
    };

    const result = await getFiles(params);

    if (result && result.status === 200) {
      files.value.content = result.data.content;
      files.value.totalElements = result.data.totalElements;
    }
  } catch (error) {
    console.log("Error al cargar archivos:", error);
  } finally {
    loading.value = false;
  }
};

const filteredFiles = computed(() => {
  if (!search.value) return files.value.content;

  const searchTerm = search.value.toLowerCase();

  return files.value.content.filter((item) =>
    item.file_name.toLowerCase().includes(searchTerm) ||
    item.category.toLowerCase().includes(searchTerm) ||
    item.author?.toLowerCase().includes(searchTerm)
  );
});



const seeMore = async (file) => {
  const link = BASEURL + file.file_path;

  const newTab = window.open('about:blank', '_blank');

  try {
    const response = await fetch(link, {
      method: "GET",
      headers: {
        Range: "bytes=0-1"
      }
    });

    if (response.ok) {
      newTab.location.href = link;
    } else {
      newTab.close();
      showErrorToast("El documento no existe");
    }
  } catch (error) {
    newTab.close();
    console.error("Error checking document:", error);
    showErrorToast("Error al verificar el documento");
  }
};

const deleteFile = async (params) => {
  try {
    const result = await deleteFileService(params.id);
    if (result && result.status === 200) {
      if (params.status === "ACTIVE") {
        showSuccessToast("Archivo eliminado");
      } else {
        showSuccessToast("Archivo activado");
      }
      loadItems();
    }
  } catch (error) {
    console.log("Error al eliminar archivo:", error);
  }
};

const editFile = (file) => {
  selectedFile.value = file;
  showModalUpdateFile.value = true;
};

const newFile = async () => {
  showModalAddFile.value = true;
};

const closeModalUpdate = () => {
  showModalUpdateFile.value = false;
  selectedFile.value = null;
};
</script>

<style scoped>
.badge-active {
  background-color: yellowgreen;
  color: white;
  padding: 5px 10px;
  border-radius: 12px;
}

.badge-inactive {
  background-color: orange;
  color: white;
  padding: 5px 10px;
  border-radius: 12px;
}

.badge-unknown {
  background-color: orange;
  color: white;
  padding: 5px 10px;
  border-radius: 12px;
}

.badge-default {
  background-color: blue;
  color: white;
  padding: 5px 10px;
  border-radius: 12px;
}



.fa-trash:hover {
  color: red;
}

.fa-file:hover {
  color: rgb(34, 99, 127);
}

.fa-eye:hover {
  color: rgb(79, 127, 34);
}

.fa-circle-check:hover {
  color: green;
}

.btn-add-user {
  background-color: black;
  color: white;
}

.btn-add-user:hover {
  background-color: orange;
  color: #000;
}
</style>
